var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEye2 = function SvgEye2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5854 12.7081C22.5376 14.5213 21.0313 16.027 19.2175 17.0737C17.4038 18.1205 15.3465 18.6716 13.2524 18.6716C11.1583 18.6716 9.10103 18.1205 7.28728 17.0737C5.47354 16.027 3.96715 14.5213 2.91943 12.7081C3.96507 10.8922 5.47072 9.38398 7.28474 8.33526C9.09875 7.28654 11.1571 6.73437 13.2524 6.73438C15.3477 6.73437 17.406 7.28654 19.22 8.33526C21.0341 9.38398 22.5397 10.8922 23.5854 12.7081Z",
    stroke: "#2555EF",
    strokeWidth: 0.948522,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2531 16.0797C15.1141 16.0797 16.6228 14.5709 16.6228 12.7098C16.6228 10.8486 15.1141 9.33984 13.2531 9.33984C11.392 9.33984 9.8833 10.8486 9.8833 12.7098C9.8833 14.5709 11.392 16.0797 13.2531 16.0797Z",
    stroke: "#2555EF",
    strokeWidth: 0.948522,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eye2.e6613273.svg";
export { ForwardRef as ReactComponent };